import { _t } from "@cruisen/i18n"
import styles from "./styles.module.scss"
import classNames from "classnames"
import { CollaboratorJoinedTripNotificationData } from "@cruisen/contract"

export const JoinedWelcomeMessage = ({
  data,
  showAvatarAndName,
}: {
  data: CollaboratorJoinedTripNotificationData
  showAvatarAndName: boolean
}) => {
  return (
    <>
      <div
        className={classNames([
          styles.firstBox,
          showAvatarAndName ? styles.lastMessageNotNavigator : styles.lastMessageNavigator,
        ])}
      >
        <p>{_t("navigatorSystemMessageComponents.joinTripWelcomeOne", { ...data })}</p>
      </div>
    </>
  )
}
